import { createSlice } from "@reduxjs/toolkit";
import { getRelatedProducts } from "./relatedProductsAction";

const initialState = {
  loading: false,
  relatedItems: {},
  success: false,
  error: null,
};
const relatedProductsSlice = createSlice({
  name: "relatedProducts",
  initialState,
  reducers: {
    resetRelatedProductsError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRelatedProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRelatedProducts.fulfilled, (state, action) => {
        state.relatedItems = action.payload;
        state.loading = false;
      })
      .addCase(getRelatedProducts.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { resetRelatedProductsError } = relatedProductsSlice.actions;
export default relatedProductsSlice.reducer;
